import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    page: null,
    mode: '',
    approval_request_list: [],
    table: {
      selected_changes: [],
      loading: false,
      total_items: 0,
      admin_headers: [
        { title: Vuetify.locale.t('$vuetify.__Approval.current_version'), key: 'source_value', width: 145 },
        { title: Vuetify.locale.t('$vuetify.__Approval.new_version'), key: 'target_value', width: 126 },
        { title: Vuetify.locale.t('$vuetify.__Approval.section'), key: 'field_name', width: 95 },
        { title: Vuetify.locale.t('$vuetify.__Approval.changed_by'), key: 'changed_by_username', width: 124 },
        { title: Vuetify.locale.t('$vuetify.__Approval.date_time'), key: 'changed_at', width: 120 }
      ],
      editor_headers: [
        { title: Vuetify.locale.t('$vuetify.__Approval.current_version'), key: 'source_value', width: 145 },
        { title: Vuetify.locale.t('$vuetify.__Approval.new_version'), key: 'target_value', width: 126 },
        { title: Vuetify.locale.t('$vuetify.__Approval.section'), key: 'field_name', width: 95 }
      ]
    },
    changes_detail: {
      approval_id: null,
      device_id: null,
      device_name: '',
      approved: null,
      not_approved: null,
      diff: []
    },
    is_submit_btn_disable: false
  },
  mutations: {
    INIT_CHANGES_APPROVAL_DIALOG(state) {
      state.visibility = true
    },
    RESET_CHANGES_APPROVAL_DIALOG(state) {
      state.visibility = false
      state.page = null
    },
    SET_CHANGES_APPROVAL_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_MODE(state, payload) {
      state.mode = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_PAGE(state, payload) {
      state.page = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_APPROVAL_REQUEST_LIST(state, payload) {
      state.approval_request_list = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_CHANGES_DETAIL(state, payload) {
      state.changes_detail = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_CHANGES_DETAIL_APPROVAL_ID(state, payload) {
      state.changes_detail.approval_id = payload
    },
    SET_CHANGES_APPROVAL_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    }
  },
  actions: {
    initChangeApprovalDialog({ commit, dispatch }, payload) {
      commit('SET_CHANGES_APPROVAL_DIALOG_MODE', payload.mode)
      if (payload.mode === 'editor') {
        commit('SET_CHANGES_APPROVAL_DIALOG_PAGE', 1)
        commit('INIT_CHANGES_APPROVAL_DIALOG')
        dispatch('fetchChangesList', payload)
      } else if (payload.mode === 'admin') {
        commit('SET_CHANGES_APPROVAL_DIALOG_PAGE', 0)
        commit('INIT_CHANGES_APPROVAL_DIALOG')
      }
    },
    async fetchApprovalRequestList({ commit }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''),
          loading: true
        })
        commit('SET_CHANGES_APPROVAL_DIALOG_LOADING', true)
        commit('SET_CHANGES_APPROVAL_DIALOG_APPROVAL_REQUEST_LIST', [])

        const response = await api.getApprovalRequest()
        if (response.data.success) {
          commit('SET_CHANGES_APPROVAL_DIALOG_APPROVAL_REQUEST_LIST', response.data.data.approval_requests)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CHANGES_APPROVAL_DIALOG_LOADING', false)
      }
    },
    async fetchChangesList({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''),
          loading: true
        })
        commit('SET_CHANGES_APPROVAL_DIALOG_LOADING', true)
        commit('SET_CHANGES_APPROVAL_DIALOG_CHANGES_DETAIL', { name: '', id: null, changes: null, approved: null, not_approved: null, diff: [] })

        const response = await api.getDeviceChanges({ device_id: payload.device_id })
        if (response.data.success) {
          commit('SET_CHANGES_APPROVAL_DIALOG_CHANGES_DETAIL', { device_id: payload.device_id, device_name: payload.device_name, ...response.data.data })
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CHANGES_APPROVAL_DIALOG_LOADING', false)
      }
    },
    async fetchApprovalRequestDetail({ state, commit }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''),
          loading: true
        })
        commit('SET_CHANGES_APPROVAL_DIALOG_TABLE_LOADING', true)

        const response = await api.getApprovalRequestDetails({ params: { approval_id: state.changes_detail.approval_id } })
        if (response.data.success) {
          let data = JSON.parse(JSON.stringify(response.data.data))
          data.diff.forEach((diff_detail, diff_i) => {
            diff_detail.change_id = diff_i
          })
          commit('SET_CHANGES_APPROVAL_DIALOG_CHANGES_DETAIL', data)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CHANGES_APPROVAL_DIALOG_TABLE_LOADING', false)
      }
    },
    async confirmApprovalRequest({ state, commit }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''),
          loading: true
        })
        commit('SET_CHANGES_APPROVAL_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        let params = { approval_id: state.changes_detail.approval_id, diff: state.changes_detail.diff }
        const response = await api.confirmApprovalRequest({ params: params })
        if (response.data.success) {
          commit('RESET_CHANGES_APPROVAL_DIALOG')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CHANGES_APPROVAL_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
